import React from 'react';
import styled from 'styled-components';
import { Helmet } from 'react-helmet';
import theme from '~/styles/styledComponentsTheme';
import { useTikTokPost } from '~/hooks/useTikTokPost';

const Container = styled.div`
  display: flex;
  justify-content: center;
  margin: 24px 0;
`;

const TikTokEmbed = styled.div`
  && {
    > blockquote {
      padding: 0;
      @media ${theme.breakpoints.tablet} {
        min-width: 550px !important;
      }
    }
  }
`;

const TikTokPost = ({ post_id }: { post_id: string }) => {
  const tikTokEmbed = useTikTokPost(post_id);

  if (tikTokEmbed.html) {
    return (
      <Container>
        <Helmet>
          <script id="ttEmbedder" async src={tikTokEmbed.scriptSrc} />
        </Helmet>
        <TikTokEmbed dangerouslySetInnerHTML={{ __html: tikTokEmbed.html || '' }} />
      </Container>
    );
  }

  return null;
};

export default TikTokPost;
